GameView    = require "views/base/game"
convert   = require("lib/convert")
theAlphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("")
theNumerals = "0123456789".split("")

class ConstructView extends GameView
  template: require("./template")

  templates:
    letters: require("./components/letters")

  events: ->
    "iostap .letter": "onTapLetter"
    "iostap .word-hidden": "activateWord"
    "iostap .word-letters": "selectContainer"
    "iostap .btn-done": "endGame"
    "iostap": "deactivateWord"

  show: ->
    super
    @setEl @findOne(".word-letters"), "letters"
    @setEl @findOne(".statement"),    "statement"
    @setEl @findAll(".word-hidden"),  "words"

    @enterGame()

    @listenTo this, "resize", @onResize
    @listenTo this, "keypress", @onKeyPress

  onResize: ->
    for el in  @findAll(".hyphen")
      el.parentNode.removeChild(el)

    hyphen = ->
      el = document.createElement("span")
      el.classList.add "hyphen"
      el.innerHTML = "-"
      el

    width = @getEl("statement").offsetWidth
    word.classList.remove("break") for word in @getEl("words")

    for word in @getEl("words") when word.offsetWidth > width
      word.classList.add("break")
      offsetTop = word.children[0].offsetTop
      for next in word.children
        if next.offsetTop > offsetTop
          next.insertAdjacentElement("beforeBegin", hyphen())
        offsetTop = next.offsetTop

  serialize: ->
    data = super

    { title, words } = data

    title = convert.toText title or ""

    filteredWords = _.filter(words, (item) -> item != "")

    words =
      for word, i in filteredWords
        escapedWord = word.replace(/\W/g, ((w) -> "\\#{w}"))
        word = convert.toText word 
        rx   = new RegExp "([^A-Z]|^)#{escapedWord}([^A-Z]|$)", "i"
        if title.match(rx)?
          title = title.replace(rx, " {{#{i}}} ")
          word
  
    # Class assignment for large text
    length = title.length
    data.titleClass = if length > 120 then "text-lg" else ""

    data.components =
      for component in title.trim().split(" ")
        index = +component.match(/\{\{(\d+)\}\}/)?[1]
        klass: "delay-#{_.random(3)} scale-#{_.sample(["down", "up"])}"
        word: component.replace(/\{\{(\d+)\}\}/, words[index] or "")
        hidden: words[index]?

    data

  selectContainer: (e) ->
    e.stopImmediatePropagation()

  deactivateWord: (e) ->
    if activeEl = @getEl("active")
      for el in [activeEl, activeEl.querySelector(".active")]
        el?.classList.remove "active"

      @elements.active = null

      @getEl("letters").classList.remove "active"

      window.clearTimeout @timeout
      @timeout = window.setTimeout =>
        @transform @getEl("statement"), y: 0
      , 150

  activateWord: (e, el) ->
    e?.stopImmediatePropagation()
    el ?= e.currentTarget

    return if el is @getEl "active"

    @deactivateWord()

    @setEl el, "active"
    el.classList.add "active"

    @activateNextLetter(el.dataset.guess.length)

    word = el.dataset.word.slice(el.dataset.guess.length)

    if word.match(/^\d+$/)
      extra = theNumerals
    else if word.match(/\w/)
      extra = theAlphabet
    else # for non-alphabetic languages such as Chinese, Korean, etc, just duplicate the characters
      extra = word

    letters = word.split("")
    extra = _.sample extra, _.random(1, 3)
    mixed = _.shuffle letters.concat(extra)

    window.clearTimeout @timeout
    @timeout = window.setTimeout =>
      @getEl("letters").innerHTML = @templates.letters word: mixed
      offset = @getEl("letters").firstChild.offsetHeight / 2
      @transform @getEl("statement"), y: -offset
      @getEl("letters").classList.add "active"
    , 300

  onKeyPress: (e) ->
    for el in @getEl("letters").querySelectorAll(".letter")
      if not el.classList.contains("disabled") and
         el.dataset.letter.toLowerCase() is e.key.toLowerCase()
        @selectLetter e.key, el
        break

  onTapLetter: (e) ->
    e.stopImmediatePropagation()
    el = e.currentTarget
    @selectLetter(el.dataset.letter, el)

  selectLetter: (letter, el) ->
    index     = @getEl("active").dataset.guess.length
    blanks    = @getEl("active").querySelectorAll(".blank")
    next      = blanks.item(index)
    isCorrect = el.dataset.letter is next.dataset.letter

    if isCorrect
      @getEl("active").dataset.guess += next.dataset.letter

    if el.dataset.letter.toLowerCase() is next.dataset.letter.toLowerCase()
      next.classList.add "visible"
      el.classList.add "disabled"
      @activateNextLetter(index + 1)
    else
      el.classList.add "incorrect"
      window.setTimeout (-> el.classList.remove "incorrect"), 300

    if @getEl("active").dataset.guess.length is blanks.length
      @getEl("active").classList.add("disabled")
      index = _.indexOf(@getEl("words"), @getEl("active")) + 1
      @activateNextWord(index)

    @setState("touched")

  activateNextWord: (index) ->
    words = @getEl("words")
    el    = words.item(index)

    hasLetters = (el) ->
      el.querySelectorAll(".visible").length < el.dataset.word.length

    if el and hasLetters(el)
      @activateWord(null, el)
    else
      @deactivateWord()
      el = _.filter(words, hasLetters)[0]
      @activateWord(null, el) if el?

  activateNextLetter: (index = 0) ->
    blanks = @getEl("active").querySelectorAll(".blank")
    next   = blanks.item(index)

    el.classList.toggle("active", index is i) for el, i in blanks

  isCorrect: ->
    total   = @findAll(".blank").length
    visible = @findAll(".blank.visible").length
    total is visible

  answerDetails: ->

    questions = @options.metadata.questions or []
    return [] unless questions.length > 0
    details = []

    words = @$(".word-hidden")
    isCorrect = @isCorrect()

    for q in questions
      answer = _.find q.answers, (a) -> a.correct is isCorrect
      answer.content = @$(words[questions.indexOf(q)]).data("guess")
      questionDetails = question: q.question, answer: answer
      details.push questionDetails

    details

  endGame: ->
    super

    @submit()


module.exports = ConstructView
